const ae = '\u00E6';
const oe = '\u00F8';
const aa = '\u00E5';

export const PAGE_DEFINITIONS = [
  { id: 'dashboard', label: 'Dashboard', description: 'Visning af overblik og n' + oe + 'gletal.' },
  { id: 'biler', label: 'Biler', description: 'Liste og detaljer for biler.' },
  { id: 'biler_edit', label: 'Biler - Rediger', description: 'Oprettelse og redigering af biler.' },
  { id: 'stationer', label: 'Stationer', description: 'Stationoversigt og profiler.' },
  { id: 'stationer_edit', label: 'Stationer - Rediger', description: 'Oprettelse og redigering af stationer.' },
  { id: 'fejlmeldinger', label: 'Fejlmeldinger', description: 'Administration af fejlmeldinger.' },
  { id: 'services', label: 'Services', description: 'Serviceoversigt og historik.' },
  { id: 'services_selection', label: 'Servicevalg', description: 'Valg af service/skema.' },
  { id: 'services_details', label: 'Service detaljer', description: 'Registrering af service detaljer.' },
  { id: 'vaerksted', label: 'V' + ae + 'rksted', description: 'V' + ae + 'rkstedsoversigt.' },
  { id: 'vaerksted_details', label: 'V' + ae + 'rksted detaljer', description: 'Detaljer for v' + ae + 'rkstedsopgaver.' },
  { id: 'laanebiler', label: 'L' + aa + 'nebiler', description: 'Administration af l' + aa + 'nebiler.' },
  { id: 'salg', label: 'Salg', description: 'Salg og tilbud.' },
  { id: 'eftersyn', label: 'Eftersyn', description: 'Eftersynsskemaer og historik.' },
  { id: 'samarbejdspartnere', label: 'Samarbejdspartnere', description: 'Oversigt over samarbejdspartnere.' },
  { id: 'print_calculator', label: '3D Prisberegner', description: 'Beregn priser på 3D print og materialer.' },
  { id: 'b2b_partners', label: 'B2B partnere', description: 'Administration af B2B partnere.' },
  { id: 'inventory_items', label: 'Lager - Varer', description: 'Varelager og varer.' },
  { id: 'inventory_pick', label: 'Lager - Pluk', description: 'Pluk og registrering af lagerforbrug.' },
  { id: 'orders', label: 'Indk' + oe + 'b - Ordrer', description: 'Indk' + oe + 'bsordrer og modtagelse.' },
  { id: 'afspadsering', label: 'Afspadsering', description: 'Kalender og forespørgsler om afspadsering.' },
  { id: 'indstillinger', label: 'Indstillinger', description: 'System- og brugerindstillinger.' },
  { id: 'min_profil', label: 'Min profil', description: 'Visning og redigering af egen profil.' }
];

export const DEFAULT_ROLE_ACCESS = {
  admin: PAGE_DEFINITIONS.map(page => page.id),
  bruger: [
    'dashboard',
    'biler',
    'stationer',
    'fejlmeldinger',
    'services',
    'services_selection',
    'services_details',
    'vaerksted',
    'vaerksted_details',
    'laanebiler',
    'eftersyn',
    'samarbejdspartnere',
    'inventory_items',
    'inventory_pick',
    'orders',
    'afspadsering',
    'print_calculator',
    'min_profil'
  ],
  default: ['dashboard', 'min_profil']
};

export const ALWAYS_ADMIN_PAGES = ['indstillinger'];
